<template>
  <div>
    <!-- Tab Navigation -->
    <div
      style="
        margin-left: 2em;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 12px 16px;
        border-bottom: 1px solid #e5e7eb;
        background: linear-gradient(to right, #f9fafb, #f3f4f6);
      "
    >
      <a
        :href="'/setting/services/lab'"
        :class="[
          'tab-link',
          $route.fullPath == '/setting/services/lab' ? 'active-tab' : '',
        ]"
      >
        🧪 Lab Tests
      </a>

      <a
        v-if="package_contains('radiology')"
        :href="'/setting/services/radiology'"
        :class="[
          'tab-link',
          $route.fullPath == '/setting/services/radiology' ? 'active-tab' : '',
        ]"
      >
        🩻 Radiology Services
      </a>

      <a
        :href="'/setting/services/nursing'"
        :class="[
          'tab-link',
          $route.fullPath == '/setting/services/nursing' ? 'active-tab' : '',
        ]"
      >
        💉 Nursing Services
      </a>

      <a
        v-if="package_contains('inpatient')"
        :href="'/setting/services/inpatient'"
        :class="[
          'tab-link',
          $route.fullPath == '/setting/services/inpatient' ? 'active-tab' : '',
        ]"
      >
        🏥 Inpatient Services
      </a>

      <a
        :href="'/setting/services/other'"
        :class="[
          'tab-link',
          $route.fullPath == '/setting/services/other' ? 'active-tab' : '',
        ]"
      >
        ⚙️ Other Services
      </a>
    </div>
  </div>
</template>

<script>

import package_contains from "../../special_clinics/package_contains";
export default {
  name: "serviceindex",
  methods: {
    package_contains,
    activeTabChange() {
      this.loading = true;
    },
  },
  mounted() {
    console.log(this.$route.fullPath);
  },
};
</script>

<style scoped>
body {
  font-family: "Inter", sans-serif;
}

/* Base tab link styling */
.tab-link {
  display: inline-block;
  padding: 8px 16px;
  background-color: white;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* Hover effect */
.tab-link:hover {
  background-color: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
  transform: translateY(-1px);
}

/* Active tab */
.active-tab {
  background-color: #1d4ed8;
  color: white !important;
  border-color: #1d4ed8;
  box-shadow: 0 2px 4px rgba(29, 78, 216, 0.25);
  transform: translateY(-1px);
}

/* Optional: subtle transition for layout */
div[style*="flex-wrap"] {
  transition: background 0.3s ease;
}
</style>
